import { IRootState } from '../../../store'

export const getUserIdSelector = (state: IRootState): string => state.user.userId
